import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f81c5692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-composition-page" }
const _hoisted_2 = { class: "card mb-4 border-0 shadow-sm" }
const _hoisted_3 = { class: "card-body p-4 d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-2" }, null, -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash me-2" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "badge bg-info fs-6"
}
const _hoisted_10 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement de la composition...", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_16 = {
  key: 2,
  class: "composition-preview"
}
const _hoisted_17 = { class: "card mb-4 border-0 shadow-sm" }
const _hoisted_18 = { class: "card-header bg-primary text-white py-3" }
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-text-o me-2" }, null, -1))
const _hoisted_21 = { class: "card-body p-4" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "info-group mb-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "MATIÈRE", -1))
const _hoisted_26 = { class: "mb-0 fs-5" }
const _hoisted_27 = { class: "badge bg-secondary ms-2" }
const _hoisted_28 = { class: "info-group mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "FILIÈRE", -1))
const _hoisted_30 = { class: "mb-0 fs-6" }
const _hoisted_31 = { class: "info-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "NIVEAU", -1))
const _hoisted_33 = { class: "mb-0 fs-6" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "info-group mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "PROFESSEUR", -1))
const _hoisted_37 = { class: "mb-0 fs-6" }
const _hoisted_38 = { class: "info-group mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "DATE DE COMPOSITION", -1))
const _hoisted_40 = { class: "mb-0 fs-6" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar me-2" }, null, -1))
const _hoisted_42 = {
  key: 0,
  class: "info-group"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "DATE LIMITE SOUMISSION", -1))
const _hoisted_44 = { class: "mb-0 fs-6" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o me-2" }, null, -1))
const _hoisted_46 = {
  key: 0,
  class: "badge bg-danger ms-2"
}
const _hoisted_47 = {
  key: 1,
  class: "badge bg-warning ms-2"
}
const _hoisted_48 = {
  key: 1,
  class: "info-group"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted small" }, "COEFFICIENT", -1))
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = { class: "badge bg-success fs-5" }
const _hoisted_52 = { class: "card border-0 shadow-sm" }
const _hoisted_53 = { class: "card-header bg-secondary text-white py-3" }
const _hoisted_54 = { class: "mb-0" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-question-circle me-2" }, null, -1))
const _hoisted_56 = { class: "card-body p-4" }
const _hoisted_57 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }, null, -1))
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "d-flex align-items-start" }
const _hoisted_61 = { class: "question-number me-3" }
const _hoisted_62 = { class: "badge bg-primary rounded-circle p-3 fs-5" }
const _hoisted_63 = { class: "flex-grow-1" }
const _hoisted_64 = { class: "fs-6 mb-3 fw-medium" }
const _hoisted_65 = {
  key: 0,
  class: "propositions ms-3"
}
const _hoisted_66 = ["checked"]
const _hoisted_67 = { class: "form-check-label ms-2" }
const _hoisted_68 = {
  key: 0,
  class: "badge bg-success ms-2"
}
const _hoisted_69 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_70 = { class: "alert alert-info mb-0" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Réponse attendue :", -1))
const _hoisted_72 = { class: "mb-0 mt-2" }
const _hoisted_73 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-secondary mb-0" }, [
  /*#__PURE__*/_createElementVNode("em", null, "Aucune réponse modèle fournie")
], -1))
const _hoisted_75 = [
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/liste-compositions",
            class: "btn btn-outline-secondary me-2"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode("Retour ")
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadPdf && _ctx.downloadPdf(...args))),
            class: "btn btn-primary me-2",
            disabled: !_ctx.composition || !_ctx.composition.pdfUrl
          }, [
            _hoisted_6,
            _createTextVNode("Télécharger PDF ")
          ], 8, _hoisted_5),
          (_ctx.canEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editComposition && _ctx.editComposition(...args))),
                class: "btn btn-warning me-2"
              }, [
                _hoisted_7,
                _createTextVNode("Modifier ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteComposition && _ctx.deleteComposition(...args))),
                class: "btn btn-danger"
              }, [
                _hoisted_8,
                _createTextVNode("Supprimer ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_ctx.composition?.type)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.composition.type === 'QCM' ? 'QCM' : 'Questions/Réponses'), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
          ]))
        : (_ctx.composition)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("h3", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.composition.titre), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("p", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.composition.filiereNiveauMatiere?.matiere?.libelle || 'N/A') + " ", 1),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.composition.filiereNiveauMatiere?.matiere?.code), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.composition.filiereNiveauMatiere?.filiere?.libelle || 'N/A'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.composition.filiereNiveauMatiere?.niveau?.libelle || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("p", _hoisted_37, _toDisplayString(`${_ctx.composition.professeur?.nom || ''} ${_ctx.composition.professeur?.prenom || ''}`.trim()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("p", _hoisted_40, [
                          _hoisted_41,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.composition.dateComposition)), 1)
                        ])
                      ]),
                      (_ctx.composition.dateFinSoumission)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("p", _hoisted_44, [
                              _hoisted_45,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.composition.dateFinSoumission)) + " ", 1),
                              (_ctx.isExpired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Expirée "))
                                : (_ctx.daysRemaining <= 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, " J-" + _toDisplayString(_ctx.daysRemaining), 1))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.composition.filiereNiveauMatiere?.coefficient)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("p", _hoisted_50, [
                              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.composition.filiereNiveauMatiere.coefficient), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("h4", _hoisted_54, [
                    _hoisted_55,
                    _createTextVNode(" Questions (" + _toDisplayString(_ctx.composition.compoQuestions?.length || 0) + ") ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  (!_ctx.composition.compoQuestions || _ctx.composition.compoQuestions.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _hoisted_58,
                        _createTextVNode(" Aucune question n'a été ajoutée à cette composition. ")
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.composition.compoQuestions, (cq, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: cq.question.id,
                            class: _normalizeClass(["question-item mb-4 p-4 border rounded", {'bg-light': index % 2 === 0}])
                          }, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("span", _hoisted_62, _toDisplayString(index + 1), 1)
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("p", _hoisted_64, _toDisplayString(cq.question.contenu), 1),
                                (cq.question.type === 'QCM' && cq.question.propositions?.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cq.question.propositions, (prop, pIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: prop.id,
                                          class: _normalizeClass(["form-check mb-2 p-2 rounded", {'bg-success bg-opacity-10 border border-success': prop.estLaBonneReponse}])
                                        }, [
                                          _createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "radio",
                                            disabled: "",
                                            checked: prop.estLaBonneReponse
                                          }, null, 8, _hoisted_66),
                                          _createElementVNode("label", _hoisted_67, [
                                            _createElementVNode("strong", null, _toDisplayString(String.fromCharCode(65 + pIndex)) + ".", 1),
                                            _createTextVNode(" " + _toDisplayString(prop.contenu) + " ", 1),
                                            (prop.estLaBonneReponse)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_68, " ✓ Bonne réponse "))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 2))
                                      }), 128))
                                    ]))
                                  : (cq.question.reponses?.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                        _createElementVNode("div", _hoisted_70, [
                                          _hoisted_71,
                                          _createElementVNode("p", _hoisted_72, _toDisplayString(cq.question.reponses[0].contenu), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ]))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}